// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__38ac2","alertIcon":"ConfirmModal_alertIcon__2wJTt"};